/* global jQuery */
import jQuery from 'jquery';
import Svg4Everybody from 'svg4everybody';
// import Ps from 'perfect-scrollbar';
// import Select2 from 'select2';
import objectFitImages from 'object-fit-images';

// Relative Imports
import BackToTop from './modules/back-to-top'
import Filters from './modules/filters';
import SocialSharing from './modules/social-sharing';
import Header from "./modules/header";

(function ($) {
    const debug = true;
    const mobileBreakpoint = 1017;

    /**
     * Back To Top Button
     */
    new BackToTop();

    /**
     * Filters
     */
    new Filters();

    /**
     * Social sharing
     */
    new SocialSharing('.js-social-share');

    /**
     * SVG4Everybody
     */
    new Svg4Everybody();

    /**
     * Object fit polyfill
     */
    objectFitImages();

    // Select2 Example
    // new Select2();
    //
    // $('.js-sorter').select2({
    //     minimumResultsForSearch: -1,
    //     width: '100%'
    // });

    // Perfect Scrollbar Example
    // addScrollbars () {
    //     for (let i = 0; i < this.$filterLists.length; i++) {
    //         this.scrollbars.push(new Ps(this.$filterLists[i]));
    //     }
    // }
    //
    // updateScrollbars () {
    //     this.scrollbars.forEach((ps) => ps.update());
    // }


    /**
     * Init header controller
     */
    new Header(mobileBreakpoint);
}(jQuery));
